/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon16Light = forwardRef('MathDeltaIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m6.446 3-4.373 8.445A1.75 1.75 0 0 0 3.627 14h8.746a1.75 1.75 0 0 0 1.554-2.555L9.554 3.001C8.9 1.74 7.099 1.74 6.446 3Zm.54 1.094-4.012 7.817a.75.75 0 0 0 .667 1.093h8.024a.75.75 0 0 0 .667-1.092L8.32 4.094a.75.75 0 0 0-1.334 0Z" })));
});
